import axios from 'axios'
import { toast } from 'react-toastify'

const emailSubmit = async (data: any, APIEndpoint: string) => {
  try {
    const response = axios.post(APIEndpoint, JSON.stringify({ product: window.location.href, ...data }), {
      headers: {
        // Vercel's body parser is pedantic
        'Content-Type': 'application/json',
      },
    })
    console.log(response)
  } catch (error) {
    toast.error('error sending email, please call us on 02 9233 8633')
  }
}

export { emailSubmit }
